/* eslint-disable react/no-children-prop */
/* eslint-disable react/jsx-curly-brace-presence */
import { useLazyQuery } from "@apollo/client";
import { Badge, message, Tooltip } from "antd";
import dayjs from "dayjs";
import { isEmpty, isUndefined, orderBy } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { BASE_URL_FOR_STATIC_ICONS_AND_IMAGES, forum } from "../../../config";
import { GET_MORE_APPOINTMENT_DETAILS_ACTIVITY_CENTER } from "../../../graphql/query";
import useCrmIntegration from "../../../hooks/useCrmIntegration";
import useLang from "../../../hooks/useLang";
import MessageIcon from "../../../icons/js/MessageIcon";
import { DealInfoText } from "../../../library/activityComponents";
import { convertUtcToLocal } from "../../../library/utils";
import AntdIconV4 from "../../../utils/antdIcon";
import CustomLabel from "../../commonComponents/label";
import { getLeadOpportunitySource } from "../leadSourceHelper";
import { displayPhone, getLeadStatus } from "./engagementHelpers";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone"); // dependent on utc plugin

dayjs.extend(utc);
dayjs.extend(timezone);

const LeadList = props => {
  const {
    messageObject,
    user,
    item,
    sourcesData,
    handleAppointmentModalClose,
    spinner,
    selectedLeadId,
    refetchLeads,
    selectedLead,
    activeOpp,
  } = props;
  const crmIntegration = useCrmIntegration();
  const [lang] = useLang();
  const [vehicle, setvehicle] = useState("");

  const findOpp = () => {
    return (selectedLead?.leadOpportunities || []).find(item => +item.id === +activeOpp);
  };
  const opportunityObj = useMemo(findOpp, [activeOpp, selectedLead?.leadOpportunities]);

  const parseVehicles = () => {
    let latestOpportunity = item?.crmLeadObj?.activeLeadOpportunity
      ? item?.crmLeadObj?.activeLeadOpportunity
      : orderBy(item.leadOpportunities || [], item => new Date(item.updatedDate), "desc")[0];

    // Selected Opportunity vehicles
    if (opportunityObj && item.id === selectedLead?.id) {
      latestOpportunity = opportunityObj;
    }
    const voi =
      latestOpportunity?.vehiclesOfInterest &&
      latestOpportunity?.vehiclesOfInterest?.length > 0 &&
      orderBy(latestOpportunity?.vehiclesOfInterest || [], item => item.customerInterest, "asc")[0];
    if (voi) {
      let name = "";
      if (voi?.year && voi.year !== 0 && voi.year !== "" && voi.year !== "0")
        name = `${name} ${voi.year}`;
      if (voi?.make && voi.make !== 0 && voi.make !== "" && voi.make !== "0")
        name = `${name} ${voi.make}`;
      if (voi?.model && voi.model !== 0 && voi.model !== "" && voi.model !== "0")
        name = `${name} ${voi.model}`;
      return isEmpty(name) ? setvehicle("No vehicle") : setvehicle(name);
    }
    return setvehicle("No vehicle");
  };
  useEffect(() => {
    parseVehicles();
  }, [item?.leadVehicleInventory, activeOpp]);
  let leadSource = { name: "", tooltipSourceMsg: "" };
  if (["DS", "VIN", "EL", "MF"].includes(user?.company?.crmIntegrationType)) {
    const latestOpportunity =
      opportunityObj && item.id === selectedLead?.id
        ? opportunityObj
        : item?.crmLeadObj?.activeLeadOpportunity;
    leadSource.tooltipSourceMsg = getLeadOpportunitySource(
      latestOpportunity?.opportunitySource || {}
    );
    leadSource.name = `${latestOpportunity?.opportunitySource?.name || "N/A"}`;
  } else {
    leadSource =
      sourcesData?.length > 0 &&
      sourcesData.find(el => +el.id === +(item?.leadSourceOriginalId || 0));
  }

  const appointmentStatus =
    item?.activeAppointment?.appointmentStatus === "CANCELLED"
      ? "error"
      : item?.activeAppointment?.appointmentStatus === "SHOWED"
      ? "show"
      : item?.activeAppointment?.appointmentStatus === "NO_SHOWED"
      ? "noshow"
      : item?.activeAppointment?.isConfirmed
      ? "success"
      : dayjs(item?.activeAppointment?.startDatetime).format("MM/DD/YYYYTHH:mm") <
        dayjs().utc().format("MM/DD/YYYYTHH:mm")
      ? "default"
      : "processing";
  const handleTooltip = () => {
    return item?.activeAppointment?.startDatetime ? (
      <>
        <p>
          Appointment:{" "}
          {!isUndefined(item?.activeAppointment?.startDatetime)
            ? convertUtcToLocal(item?.activeAppointment?.startDatetime, "ddd, MMMM Do YYYY, h:mm A")
            : "NA"}
        </p>
        <p>
          {lang.status}: {item?.activeAppointment?.appointmentStatus || "NA"}
        </p>
      </>
    ) : (
      ""
    );
  };

  const setLeadStatus = leadItem => {
    const status = { leadStatus: "", toolTipLeadStatus: "" };
    const latestOpportunity =
      opportunityObj && item.id === selectedLead?.id
        ? opportunityObj
        : leadItem?.crmLeadObj?.activeLeadOpportunity;

    status.toolTipLeadStatus = latestOpportunity?.opportunityStatus?.parentStatus
      ? `${latestOpportunity?.opportunityStatus?.parentStatus?.name} / ${
          latestOpportunity?.opportunityStatus?.name || ""
        }`.replace(/_/g, " ")
      : latestOpportunity?.opportunityStatus?.name || "";

    status.leadStatus = latestOpportunity?.opportunityStatus?.name
      ? getLeadStatus(
          user,
          latestOpportunity?.opportunityStatus?.name,
          status.toolTipLeadStatus,
          +selectedLeadId === +leadItem?.id ? spinner : false
        )
      : leadItem?.leadStatusType?.type
      ? getLeadStatus(
          user,
          leadItem?.leadStatusType?.type,
          status.toolTipLeadStatus,
          +selectedLeadId === +leadItem?.id ? spinner : false
        )
      : "";
    return status;
  };

  const leadOpportunityStatus = setLeadStatus(item);
  const appointmentClass = status => {
    switch (status) {
      case "error":
        return "bg-red-50 border-error-500";
      case "default":
        return "bg-brand-50 border-brand-500";
      case "success":
        return "bg-green-50 border-green-500";
      case "noshow":
        return "bg-grey-50 border-grey-500";
      case "show":
        return "bg-brand-50 border-brand-500";
      default:
        return "bg-brand-50 border-brand-500";
    }
  };
  const [getAppointmntDetails, { loading: appointmentLoader }] = useLazyQuery(
    GET_MORE_APPOINTMENT_DETAILS_ACTIVITY_CENTER
  );
  const messageRef = useRef(null);

  useEffect(() => {
    if (appointmentLoader) messageRef.current = message.loading("Fetching appointment details", 0);
    else {
      messageRef.current && messageRef.current();
    }
  }, [appointmentLoader]);
  return (
    <div className="flex flex-col justify-center">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <Tooltip
            placement="topLeft"
            title={leadSource?.tooltipSourceMsg || item?.otherSource || "N/A"}
          >
            <DealInfoText
              lineHight={0}
              className="flex flex-row items-center gap-2 py-1 text-[14px] text-[#333]"
            >
              {
                <img
                  width={
                    leadSource && leadSource?.name?.toLowerCase() === "cars.com" ? "38px" : "18px"
                  }
                  src={`/images/sources/${(leadSource?.name || "marketplace")
                    .toLowerCase()
                    .replace(".", "-")}.png`}
                  onError={e => {
                    e.target.src = BASE_URL_FOR_STATIC_ICONS_AND_IMAGES + forum;
                  }}
                  className="align-middle rounded h-[18px]"
                  alt={leadSource?.name}
                />
              }

              <CustomLabel
                label={
                  (leadSource?.name || "").length <= 25
                    ? leadSource?.name || "Direct"
                    : `${leadSource?.name.substring(0, 22)}...`
                }
                labelClass="text-[14px] font-sans font-[400] text-grey-700"
              />
            </DealInfoText>
          </Tooltip>
          <div className="flex items-center gap-2">
            <AntdIconV4 type="PhoneOutlined" className="rotate-90" />
            <CustomLabel
              label={item?.phoneNumbers && displayPhone(item, crmIntegration)}
              labelClass="text-[14px] font-sans text-grey-700"
            />
          </div>

          {vehicle && !vehicle.includes("undefined") && (
            <div className="flex items-baseline mt-1 gap-2">
              <AntdIconV4 type="CarOutlined" />
              <CustomLabel label={vehicle} labelClass="text-[14px] font-sans text-grey-700" />
            </div>
          )}
        </div>
        <div>
          <div className="flex flex-col items-end gap-1">
            <Badge count={item?.unreadCount || 0} />
            {(item?.crmLeadObj?.crmStatus === "Open" ||
              (item?.leadStatusType?.type || "").includes("ACTIVE")) &&
              handleTooltip() && (
                <Tooltip placement="topLeft" title={handleTooltip()}>
                  <div
                    className={`flex-col-centered w-10 items-center cursor-pointer justify-center gap-0.5 px-2 py-1 rounded-[4px] border-[1px] border-solid ${appointmentClass(
                      appointmentStatus
                    )}`}
                    onClick={async e => {
                      const res = await getAppointmntDetails({
                        variables: {
                          appointmentId: item.activeAppointment.id,
                        },
                      });
                      const leadDetails = {
                        ...item,
                        activeAppointment: {
                          ...item.activeAppointment,
                          leadOpportunity: res?.data?.getAppointmentDetails?.leadOpportunity,
                        },
                      };
                      handleAppointmentModalClose(e, leadDetails, true);
                    }}
                  >
                    <span className="text-grey-700 text-sm font-[600]">
                      {item?.activeAppointment
                        ? convertUtcToLocal(item?.activeAppointment?.startDatetime, "DD")
                        : "N/A"}
                    </span>
                    <span className="text-grey-700 text-sm font-[400]">
                      {item?.activeAppointment
                        ? convertUtcToLocal(item?.activeAppointment?.startDatetime, "MMM")
                        : ""}
                    </span>
                  </div>
                </Tooltip>
              )}
          </div>
        </div>
      </div>
      {!isEmpty(messageObject) && (
        <div className="mt-2 line-clamp-1">
          <Tooltip
            title={
              messageObject?.messageType !== "EMAIL" ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: (
                      messageObject?.translatedContent ||
                      messageObject?.content ||
                      ""
                    )?.trim(),
                  }}
                />
              ) : (
                <span>{messageObject?.email?.subject}</span>
              )
            }
          >
            <p
              className={`${
                selectedLead && selectedLead?.id === item?.id ? "bg-brand-100" : "bg-brand-100"
              } p-1 text-grey-700 text-[12px] font-[400] rounded-[3px] font-sans pl-2 flex items-center line-clamp-1`}
            >
              <MessageIcon className="text-grey-700 mr-2 flex-shrink-0" />
              <span className="flex-1">
                {messageObject?.direction === "TO_LEAD"
                  ? `${
                      messageObject?.user?.fullName ||
                      `${messageObject?.user?.firstName} ${messageObject?.user?.lastName}` ||
                      ""
                    }`
                  : messageObject?.direction === "FROM_OTTO"
                  ? "Otto bot"
                  : item?.fullName}{" "}
                :
                <span
                  dangerouslySetInnerHTML={{
                    __html: messageObject?.translatedContent || messageObject?.content || "",
                  }}
                  className="line-clamp-1 text-ellipsis overflow-hidden align-left"
                />
              </span>
            </p>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default LeadList;
